import React from "react";
import Icon from "../icon/Icon";
import "./AppTable.css";

/// Clickable column header. `order` is "desc" | "asc" when this column is the
/// active sort, otherwise null/undefined.
const SortableHead = ({ label, order, onClick, title }) => (
  <button
    type="button"
    className={`app-table-sort${order ? " is-active" : ""}`}
    onClick={onClick}
    title={title ?? `Sort by ${label.toLowerCase()}`}
    aria-sort={
      order === "asc" ? "ascending" : order === "desc" ? "descending" : "none"
    }
  >
    <span>{label}</span>
    <Icon
      name={
        order === "asc"
          ? "arrow-long-up"
          : order === "desc"
            ? "arrow-long-down"
            : "sort"
      }
    ></Icon>
  </button>
);

/// Next sort state when a header is clicked: off → desc → asc → off.
export const nextSort = (current, key) => {
  if (current.sortBy !== key) return { sortBy: key, sortOrder: "desc" };
  if (current.sortOrder !== "asc") return { sortBy: key, sortOrder: "asc" };
  return { sortBy: undefined, sortOrder: undefined };
};

export default SortableHead;
